import { officeIsComposeMode } from './office-mail-mode'
import { officeApiItem_SubjectGetAsync, officeApiItem_SubjectSetAsync } from './async/office-api-mailbox-item-async'

export async function officeSubject(): Promise<string> {
  if (officeIsComposeMode()) {
    return officeApiItem_SubjectGetAsync()
  } else {
    return Office.context.mailbox.item.subject || ''
  }
}

const exportFunctions = {
  get: officeSubject,
  set: officeApiItem_SubjectSetAsync,
}

export default exportFunctions
